import { ApiStrategyTemplate } from 'api/rtk-api'

import { EditStrategiesActions } from '../../../../modules/strategy-admin/state/edit-strategy-slice'
import { Errors } from '../../../../modules/tradebuilder-v2/util'
import { Attribute, FormItem, Label, NumberInput, ValidationMessage } from '../..'

type VolTargetParameterInputProps = {
  actions: EditStrategiesActions
  errors: Errors
  strat: ApiStrategyTemplate
}

function round(val: number, pow: number) {
  const exp = 10 ** pow
  const res = Math.round(val * exp) / exp
  return res
}

export function VolTargetParameterInput({ actions, errors, strat }: VolTargetParameterInputProps) {
  return (
    <FormItem>
      <Label>Target volatility</Label>
      <Attribute nameComponent="Minimum (%)">
        <NumberInput
          value={strat.minTargetVolatility === 0 ? '' : round(strat.minTargetVolatility * 100, 2)}
          onChange={v => actions.setMinTargetVol(round(Number(v.target.value) / 100, 4))}
        />
      </Attribute>
      <Attribute nameComponent="Default (%)">
        <NumberInput
          value={
            strat.defaultTargetVolatility === 0 ? '' : round(strat.defaultTargetVolatility * 100, 2)
          }
          onChange={v => actions.setDefaultTargetVol(round(Number(v.target.value) / 100, 4))}
        />
      </Attribute>
      <Attribute nameComponent="Maximum (%)">
        <NumberInput
          value={strat.maxTargetVolatility === 0 ? '' : round(strat.maxTargetVolatility * 100, 2)}
          onChange={v => actions.setMaxTargetVol(round(Number(v.target.value) / 100, 4))}
        />
      </Attribute>
      <ValidationMessage errors={errors} fieldName="target_vols" />
      <ValidationMessage errors={errors} fieldName="min_target_vol" />
      <ValidationMessage errors={errors} fieldName="max_target_vol" />
    </FormItem>
  )
}
